export default __webpack_public_path__ + "static/media/client-2.6b5a3d54.png";